import { __assign } from "tslib";
import React from "react";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { Check } from "../check";
import { CheckboxGroup } from "./CheckboxGroup";
export var Checkbox = forwardRefWithStatics(function (props, ref) {
    return React.createElement(Check, __assign({ ref: ref }, props));
}, 
// statics
{
    Group: CheckboxGroup,
});
//# sourceMappingURL=Checkbox.js.map